import { IDoctorData, IDoctorSpecialty } from "../providers/doctorsData/types";
import { IFilters } from "../providers/filters/types";

export interface IListCachePayload {
  doctors: IDoctorData[];
  specs: IDoctorSpecialty[];
  insurances: IDoctorSpecialty[];
  doctorsCount: string;
  pages: number;
  page: number;
}

interface IListCacheEntry {
  savedAt: number;
  payload: IListCachePayload;
}

const PREFIX = "cdp_list_v1_";
export const LIST_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

export const buildListCacheKey = (f: IFilters): string =>
  PREFIX +
  [
    f.idPartner,
    f.search,
    f.spec,
    f.insurance,
    f.location,
    f.scheduType,
    f.selectedState,
    f.selectedCity,
    f.date,
    f.page,
  ]
    .map((v) => encodeURIComponent(String(v ?? "")))
    .join("|");

export const readListCache = (key: string): IListCachePayload | null => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const entry = JSON.parse(raw) as IListCacheEntry;
    if (!entry?.payload || !Array.isArray(entry.payload.doctors)) return null;

    if (Date.now() - entry.savedAt > LIST_CACHE_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return entry.payload;
  } catch {
    return null;
  }
};

export const writeListCache = (key: string, payload: IListCachePayload): void => {
  try {
    localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), payload }));
  } catch {
    // localStorage cheio/indisponível: cache é opcional
  }
};
